import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Chip } from '@metarouter-private/mr-mui';

export default function ReadOnlyEventTypes({ webhookConfig }) {
  const subscriptions = webhookConfig.webhookConfigEventSubscriptions;

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" color="text.secondary">
        Subscribed Events
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {subscriptions.map(sub => (
          <Chip key={sub.eventType} label={sub.eventType} size="small" />
        ))}
        {subscriptions.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No events subscribed.
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

ReadOnlyEventTypes.propTypes = {
  webhookConfig: PropTypes.shape({
    webhookConfigEventSubscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        eventType: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
